module.exports = __webpack_public_path__ + "img/mon_64.fcf14c25.png";